<template>
  <div
    class="fapi-form-warning f-px-4 f-py-2 f-relative f-border-white-400 f-border f-text-white f-rounded-t-md f-font-semibold f-bg-orange-500 f--mb-0.5"
    role="alert"
    style="background-color: #ffa830"
  >
    {{ message }}
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "Warning",

  props: {
    message: {
      type: String,
      required: true,
    },
    scrollIntoView: {
      type: Boolean,
      default: false,
    },
  },

  mounted(): void {
    if (!this.scrollIntoView) {
      return;
    }

    this.$el.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  },
});
</script>

<style lang="scss"></style>
